const CHANNEL_NAME = 'instapaper-auth';
const LOGOUT_MESSAGE = 'logout';

// A single channel shared by the sender and the listener within this tab. A
// BroadcastChannel never delivers a message to the instance that sent it, so
// reusing one instance means the tab that initiates the logout won't react to
// its own broadcast (and race the logout navigation it already performs) —
// only other tabs, which have their own instance, do.
let sharedChannel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!sharedChannel) sharedChannel = new BroadcastChannel(CHANNEL_NAME);
  return sharedChannel;
}

/**
 * Notify other open tabs that the user has logged out, so they can redirect to
 * the login page immediately rather than sitting on stale content until their
 * next request fails. No-op where BroadcastChannel is unavailable — the 401
 * handler in the data-fetch layer remains the backstop.
 */
export function broadcastLogout(): void {
  getChannel()?.postMessage(LOGOUT_MESSAGE);
}

/**
 * Subscribe to logout broadcasts from other tabs. Returns an unsubscribe
 * function to be called on unmount.
 */
export function onLogoutBroadcast(handler: () => void): () => void {
  const channel = getChannel();
  if (!channel) return () => {};

  const listener = (event: MessageEvent) => {
    if (event.data === LOGOUT_MESSAGE) handler();
  };
  channel.addEventListener('message', listener);

  return () => channel.removeEventListener('message', listener);
}
